import { APP_INITIALIZER, Provider } from '@angular/core';
import { Router } from '@angular/router';
import { TraceService } from '@sentry/angular';
import { getSentryConfig, isSentryEnabled } from './sentry-init';

export function provideSentryTracing(): Provider[] {
  const tracesSampleRate = getSentryConfig()?.tracesSampleRate ?? 0;
  if (!isSentryEnabled() || tracesSampleRate <= 0) {
    return [];
  }
  return [
    { provide: TraceService, deps: [Router] },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [TraceService],
      multi: true,
    },
  ];
}
